/**
 * Site Viewer — Single-pane iframe overlay for infrastructure links
 */
export class SiteViewer {
  #overlay;
  #frame;
  #titleEl;
  #urlEl;
  #externalLink;

  constructor() {
    this.#overlay = document.getElementById('siteViewer');
    this.#frame = document.getElementById('svOriginalFrame');
    this.#titleEl = document.getElementById('svTitle');
    this.#urlEl = document.getElementById('svUrl');
    this.#externalLink = document.getElementById('svExternal');

    this.#attachListeners();
  }

  #attachListeners() {
    document.getElementById('svClose')?.addEventListener('click', () => this.close());

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.#overlay.classList.contains('active')) {
        this.close();
      }
    });
  }

  open(name, url) {
    this.#titleEl.textContent = name;
    this.#urlEl.textContent = url;
    this.#externalLink.href = url;

    this.#overlay.classList.add('active');
    this.#overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    this.#frame.src = url;
  }

  close() {
    this.#overlay.classList.remove('active');
    this.#overlay.setAttribute('aria-hidden', 'true');
    this.#frame.src = '';
    document.body.style.overflow = '';
  }
}
